<template>
  <button
    type="button"
    class="help-file-chip"
    :disabled="!canDownload || busy"
    :title="error || label"
    @click="download"
  >
    <font-awesome-icon :icon="busy ? 'spinner' : 'file-lines'" :spin="busy" />
    <span class="help-file-label">{{ label }}</span>
    <span v-if="status && status !== 'ready'" class="help-file-status">{{ statusLabel(status) }}</span>
  </button>
</template>

<script setup>
import { computed, ref } from 'vue';
import { db } from '../../../db.js';
import { statusLabel } from './helpChatFiles.mjs';

const props = defineProps({
  label: { type: String, required: true },
  path: { type: String, default: '' },
  status: { type: String, default: '' },
  error: { type: String, default: '' },
});

const busy = ref(false);
const canDownload = computed(() => Boolean(props.path) && (!props.status || props.status === 'ready'));

async function download() {
  if (!canDownload.value || busy.value) return;
  busy.value = true;
  try {
    const url = await db.download(props.path);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.click();
  } catch (error) {
    console.error('[HelpChat] Could not download file', error);
  } finally {
    busy.value = false;
  }
}
</script>

<style scoped>
.help-file-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 100%;
  margin: 0.1rem;
  padding: 0.15rem 0.55rem;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #f9fafb;
  color: #1f2937;
  line-height: 1.4rem;
}

.help-file-chip:disabled {
  opacity: 0.7;
}

.help-file-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.help-file-status {
  color: #6b7280;
  font-size: 0.7rem;
}
</style>
